import { useCallback } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useDispatch } from '@spcc/core'
import { TenantsSection } from '@spcc/domains/tenants'
import { usersActions } from '@spcc/domains/users'

export const Route = createFileRoute('/admin/tenants')({
  component: TenantsPage,
})

type DispatchFn = ReturnType<typeof useDispatch>
type NavigateFn = ReturnType<typeof useNavigate>

function buildTenantUsersFilter(tenantId: string) {
  return {
    tenantId,
    status: 'all' as const,
    role: 'all' as const,
    search: undefined,
    page: 1,
  }
}

function handleViewTenantUsers(params: {
  tenantId: string
  dispatch: DispatchFn
  navigate: NavigateFn
}): void {
  const { tenantId, dispatch, navigate } = params
  dispatch(usersActions.setFilter(buildTenantUsersFilter(tenantId)))
  navigate({ to: '/admin/users' })
}

function TenantsPage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onViewUsers = useCallback(
    (tenantId: string) => handleViewTenantUsers({ tenantId, dispatch, navigate }),
    [dispatch, navigate]
  )

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('admin.tenantManagement', 'Tenant Management')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('admin.tenantManagementSubtitle', 'Manage organizations and their access')}
        </p>
      </div>
      <TenantsSection onViewUsers={onViewUsers} />
    </div>
  )
}
